import Fontawesome from 'react-fontawesome';
import moment from 'moment';

export const ActivityTableItem = ({
  type,
  work,
  referer,
  pages_viewed,
  occurred_at,
}) => {
  switch (type) {
    case 'download':
      return (
        <ItemBase
          icon="arrow-down"
          iconClassName="u-tcGreen"
          title={work.title}
          titleUrl={work.internal_url}
        >
          <span>Downloaded</span>
          <InlineData type="date" data={occurred_at} />
          <InlineData type="referer" data={referer} />
        </ItemBase>
      );

    case 'work_view':
      return (
        <ItemBase
          icon="eye"
          iconClassName="u-tcOrange"
          title={work.title}
          titleUrl={work.internal_url}
        >
          <span>Read</span>
          <InlineData type="date" data={occurred_at} />
          <InlineData type="referer" data={referer} />
          <InlineData type="pages_viewed" data={pages_viewed} />
        </ItemBase>
      );

    case 'bookmark':
      return (
        <ItemBase
          icon="bookmark"
          iconClassName="u-tcBlue"
          title={work.title}
          titleUrl={work.internal_url}
        >
          <span>Bookmarked</span>
          <InlineData type="date" data={occurred_at} />
          <InlineData type="referer" data={referer} />
          <InlineData type="pages_viewed" data={pages_viewed} />
        </ItemBase>
      );

    case 'certification':
      return (
        <ItemBase
          icon="check"
          iconClassName="u-tcGreen"
          title={work.title}
          titleUrl={work.internal_url}
        >
          <span>Recommended</span>
          <InlineData type="date" data={occurred_at} />
          <InlineData type="referer" data={referer} />
          <InlineData type="pages_viewed" data={pages_viewed} />
        </ItemBase>
      );

    case 'profile_view':
      return (
        <ItemBase
          icon="eye"
          iconClassName="u-tcOrange"
          title="Your Profile"
          titleUrl={Aedu.User.current.url}
        >
          <InlineData type="date" data={occurred_at} />
          <InlineData type="referer" data={referer} />
        </ItemBase>
      );
    case 'work_share':
      return (
        <ItemBase
          icon="share"
          iconClassName="u-tcBlack"
          title={work.title}
          titleUrl={work.internal_url}
        >
          <span>Shared on Academia</span>
          <InlineData type="date" data={occurred_at} />
        </ItemBase>
      );
    default:
      return null;
  }
};

export const PublicBookmark = ({ title, authors, url }) => (
  <ItemBase
    icon="bookmark"
    iconClassName="u-tcBlue"
    title={title}
    titleUrl={url}
  >
    <span>Bookmarked</span>
    <span>by {authors.map(InlineAuthor)}</span>
  </ItemBase>
);

// templates and internal component reuse for above
////////////////////////////////////////////////////////////
const InlineAuthor = ({ display_name, url }) => (
  <span className="wp-usercard-main-row__subtitle__author" key={url} href={url}>
    {display_name}
  </span>
);

const ItemBase = ({ children, title, icon, iconClassName, titleUrl }) => {
  return (
    <tr className="wp-usercard-main-row">
      <td className="wp-usercard-main-row__icon">
        <Fontawesome fixedWidth name={icon} className={iconClassName} />
      </td>
      <td>
        <div className="wp-usercard-main-row__content">
          <div className="wp-usercard-main-row__title truncate">
            <a href={titleUrl}>{title}</a>
          </div>
          <div className="wp-usercard-main-row__subtitle truncate">
            {children}
          </div>
        </div>
      </td>
    </tr>
  );
};

const InlineData = ({ type, data }) => {
  if (!data) return null;

  switch (type) {
    case 'date':
      return <span>{moment(data).format('MM/DD/YY')}</span>;
    case 'referer':
      return <span>{data.name || data.domain}</span>;
    case 'pages_viewed':
      return (
        <span>
          {data} {$h.pluralize(data, 'Page') + ' Read'}
        </span>
      );
    default:
      return null;
  }
};
